import styled from 'styled-components';
import React, { useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

export interface FreeTextInputProps {
  initialValue?: string;
  onChange?: (value: string) => void;
}

export function FreeTextInput({ initialValue, onChange }: FreeTextInputProps) {
  const [value, setValue] = useState(initialValue || ``);

  const onTextChanged = useDebouncedCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.value;
      setValue(newValue);
      onChange?.(newValue);
    },
    500,
  );

  return (
    <Wrapper>
      <input defaultValue={value} onChange={onTextChanged} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;

  input {
    width: 100%;
    border: none;
    outline: none;
    appearance: none;
    font-size: 1.4rem;
    color: rgb(75, 85, 100);
    font-family: Inter, sans-serif;
    font-weight: 500;
    text-align: end;

    :focus {
      border: none;
      outline: none;
      appearance: none;
    }
  }
`;
